import React, { useEffect, useState, useContext } from "react";
import Loading from "../Shared/Loading";
import Grid from "@mui/material/Grid";
import Footer from "../Footer/Footer";

import WOW from 'wowjs';

import MainImage from "../Model/MainImage";
import VideoIntro from "../Model/VideoIntro";
import ImageGallery from "../Model/ImageGallery";
import VideoGallery from "../Model/VideoGallery";
import GeneralArrangements from "../Model/GeneralArrangements";
import TechData from "../Model/TechData";
import LocalDoc from "../Model/LocalDoc";
import IntroSection from "../Model/IntroSection";
import ImageAnimation from "../Model/ImageAnimation";
import ImageAnimationDouble from "../Model/ImageAnimationDouble";

export const Catalog = (props) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        new WOW.WOW({
            boxClass: 'wow', // default
            animateClass: 'animated', // default
            offset: 0, // default
            mobile: true, // default
            live: false
        }).init();
    }, []);

    return (
        <Grid container spacing={4} className="vh-100" p={2}>

        </Grid>

    );
};

export default Catalog;
